export default {
  state: {
    postulation: null,
    language: null,
    program: null,
    postulationIsNull: true,
    advisory: null,
    examFinished: null,
    extraMinutes: process.env.VUE_APP_SCHEDULE_EXTRA_MINUTES,
    scoreResult: null,
    recognition: null
  },
  getters: {
    postulation: (state) => state.postulation,
    language: (state) => state.language,
    program: (state) => state.program,
    postulationIsNull: (state) => state.postulationIsNull,
    scoreResult: (state) => state.scoreResult,
    advisory: (state) => state.advisory,
    examFinished: (state) => state.examFinished,
    extraMinutes: (state) => state.extraMinutes,
    recognition: (state) => state.recognition
  },
  mutations: {
    setLanguage(state, language) {
      state.language = language;
    },
    setProgram(state, program) {
      state.program = program;
    },
    setPostulation(state, postulation) {
      state.postulation = postulation;
    },
    setScoreResult(state, scoreResult) {
      //console.log(scoreResult);
      state.scoreResult = scoreResult;
    },
    setPostulationIsNull(state, postulationIsNull) {
      state.postulationIsNull = postulationIsNull;
    },
    setAdvisory(state, advisory) {
      state.advisory = advisory;
    },
    setExamFinished(state, examFinished) {
      state.examFinished = examFinished;
    },
    setRecognition(state, recognition) {
      state.recognition = recognition;
    }
  },
  actions: {
    verifyPostulation({ commit, state }) {
      //console.log(state);

      if (
        state.postulation == null &&
        state.language == null &&
        state.program == null
      ) {
        commit("setPostulationIsNull", true);
      } else {
        commit("setPostulationIsNull", false);
      }
    },
  },
};
